import { render } from "./DropDownMenu.vue?vue&type=template&id=2fe7248c&scoped=true"
import script from "./DropDownMenu.vue?vue&type=script&lang=js"
export * from "./DropDownMenu.vue?vue&type=script&lang=js"

import "./DropDownMenu.vue?vue&type=style&index=0&id=2fe7248c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2fe7248c"

export default script